module.exports = "/assets/images/crying.png";